<div
	class="bp-gallery builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
>
	<div
		class="bp-gallery builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
	>
		<div class="gallery-row" *ngIf="data.page_gallery"
			[class.full]="data.page_gallery.length === 1"
			[class.dense]="data.page_gallery.length > 2"
		>
			<div
				*ngFor="let gallery of data.page_gallery"
			>
				<a
					*ngIf="gallery.url"
					[href]="gallery.url"
					class="gallery-single"
					target="_blank"
				>
					<img
						class="gallery-image"
						[class.large-only]="gallery.thumbnail_mobile && gallery.thumbnail_mobile.url"
						[src]="gallery.thumbnail.url"
						[alt]="gallery.thumbnail.custom_properties.alt_text"
						[height]="gallery.thumbnail.height"
						[width]="gallery.thumbnail.width"
					>
					<img *ngIf="gallery.thumbnail_mobile && gallery.thumbnail_mobile.url"
						class="gallery-image small-only"
						[src]="gallery.thumbnail_mobile.url"
						[alt]="gallery.thumbnail_mobile.custom_properties.alt_text"
						[height]="gallery.thumbnail_mobile.height"
						[width]="gallery.thumbnail_mobile.width"
					>
				</a>

				<div *ngIf="!gallery.url" class="gallery-single">
					<img
						class="gallery-image"
						[class.large-only]="gallery.thumbnail_mobile && gallery.thumbnail_mobile.url"
						[src]="gallery.thumbnail.url"
						[alt]="gallery.thumbnail.custom_properties.alt_text"
						[height]="gallery.thumbnail.height"
						[width]="gallery.thumbnail.width"
					>
					<img *ngIf="gallery.thumbnail_mobile && gallery.thumbnail_mobile.url"
						class="gallery-image small-only"
						[src]="gallery.thumbnail_mobile.url"
						[alt]="gallery.thumbnail_mobile.custom_properties.alt_text"
						[height]="gallery.thumbnail_mobile.height"
						[width]="gallery.thumbnail_mobile.width"
					>
				</div>
			</div>
		</div>
	</div>
</div>